module.exports = __webpack_public_path__ + "static/media/paypal_title.a85120e3.svg";